var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "151px",
    height: "282px",
    viewBox: "0 0 151 282",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-20.6%",
    y: "-14.6%",
    width: "141.2%",
    height: "129.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.146962413 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Where-is-my-account-number",
    transform: "translate(-180.000000, -40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statement-Lockup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statement",
    filter: "url(#filter-1)",
    transform: "translate(0.000000, 83.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 131,
    height: 185
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#006AFF",
    x: 0,
    y: 0,
    width: 131,
    height: 16.8181818
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0E9FF",
    x: 81.0952381,
    y: 33.6363636,
    width: 49.9047619,
    height: 151.363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#42484D",
    opacity: 0.500511533,
    x: 87.3333333,
    y: 39.2424242,
    width: 37.4285714,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#006AFF",
    opacity: 0.504975818,
    x: 87.3333333,
    y: 47.962963,
    width: 18.7142857,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#42484D",
    opacity: 0.296061198,
    x: 87.3333333,
    y: 62.9124579,
    width: 37.4285714,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#006AFF",
    opacity: 0.296898251,
    x: 87.3333333,
    y: 71.6329966,
    width: 18.7142857,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#42484D",
    opacity: 0.296061198,
    x: 87.3333333,
    y: 115.858586,
    width: 37.4285714,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#006AFF",
    opacity: 0.296898251,
    x: 87.3333333,
    y: 124.579125,
    width: 18.7142857,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#42484D",
    opacity: 0.296061198,
    x: 87.3333333,
    y: 92.1885522,
    width: 25.5761905,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#006AFF",
    opacity: 0.296898251,
    x: 87.3333333,
    y: 100.909091,
    width: 37.4285714,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("g", {
    id: "Latitude-/-Symbol-Only-/-White",
    transform: "translate(4.366667, 3.425926)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7531338,8.23778169 L1.7531338,0.00334507042 L0.00718309859,0.00334507042 L0.00718309859,9.98447183 L9.98408451,9.98447183 L9.98408451,8.23778169 L1.7531338,8.23778169 L1.7531338,8.23778169 Z M9.11112676,2.7481338 C8.62897887,2.7481338 8.2381338,3.13915493 8.2381338,3.62151408 C8.2381338,4.10383803 8.62897887,4.49485915 9.11112676,4.49485915 C9.59323944,4.49485915 9.98408451,4.10383803 9.98408451,3.62151408 C9.98408451,3.13915493 9.59323944,2.7481338 9.11112676,2.7481338 L9.11112676,2.7481338 Z M9.11112676,0.00334507042 C8.62897887,0.00334507042 8.2381338,0.394330986 8.2381338,0.876690141 C8.2381338,1.35901408 8.62897887,1.75003521 9.11112676,1.75003521 C9.59323944,1.75003521 9.98408451,1.35901408 9.98408451,0.876690141 C9.98408451,0.394330986 9.59323944,0.00334507042 9.11112676,0.00334507042 L9.11112676,0.00334507042 Z M9.11112676,5.49295775 C8.62897887,5.49295775 8.2381338,5.88397887 8.2381338,6.36630282 C8.2381338,6.84866197 8.62897887,7.23964789 9.11112676,7.23964789 C9.59323944,7.23964789 9.98408451,6.84866197 9.98408451,6.36630282 C9.98408451,5.88397887 9.59323944,5.49295775 9.11112676,5.49295775 L9.11112676,5.49295775 Z M7.24042254,0.876690141 C7.24042254,0.394330986 6.84957746,0.00334507042 6.36746479,0.00334507042 C5.8853169,0.00334507042 5.49447183,0.394330986 5.49447183,0.876690141 C5.49447183,1.35901408 5.8853169,1.75003521 6.36746479,1.75003521 C6.84957746,1.75003521 7.24042254,1.35901408 7.24042254,0.876690141 L7.24042254,0.876690141 Z M3.62380282,1.75003521 C3.14169014,1.75003521 2.75084507,1.35901408 2.75084507,0.876690141 C2.75084507,0.394330986 3.14169014,0.00334507042 3.62380282,0.00334507042 C4.1059507,0.00334507042 4.49679577,0.394330986 4.49679577,0.876690141 C4.49679577,1.35901408 4.1059507,1.75003521 3.62380282,1.75003521 L3.62380282,1.75003521 Z",
    id: "Latitude-Symbol"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#006AFF",
    x: 81.0952381,
    y: 84.7138047,
    width: 49.9047619,
    height: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#006AFF",
    strokeWidth: 4,
    fillRule: "nonzero",
    cx: 105,
    cy: 128.5,
    rx: 28,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Account-Number:",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    linespacing: 18,
    fill: "#42484D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14,
    y: 29
  }, "Account Number:")), /*#__PURE__*/React.createElement("text", {
    id: 1234567,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    linespacing: 18,
    fill: "#006AFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22,
    y: 47
  }, "(7 to 12 digits)")), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#006AFF",
    strokeWidth: 4,
    fillRule: "nonzero",
    cx: 67.5,
    cy: 33.5,
    rx: 65.5,
    ry: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,34 L135,131 L134.696191,131 C134.896406,130.183493 135,129.348803 135,128.5 C135,118.835017 121.568542,111 105,111 C88.4314575,111 75,118.835017 75,128.5 C75,129.348803 75.1035941,130.183493 75.3038094,131 L75,131 L11.3277087,52.0822305 C23.4313154,61.0763211 44.0717834,67 67.5,67 C104.442478,67 134.453456,52.2712774 134.992619,34.0005071 Z",
    id: "Combined-Shape",
    fill: "#006AFF",
    fillRule: "nonzero",
    opacity: 0.3
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNumber);
export default __webpack_public_path__ + "static/media/account-number.e704ab4d.svg";
export { ForwardRef as ReactComponent };